import React, { useState } from "react";

export default function DusKaDum({ data }) {
  const casinoIndividualResultDTO = data?.casinoIndividualResultDTO || {};
  const {
    marketId = "N/A",
    createdAt = "",
    casinoCardResultMaps = [],
    casinoIndividualResultMaps = [],
  } = casinoIndividualResultDTO;

  // Helper to get result by label
  const getResultValue = (label) =>
    casinoIndividualResultMaps.find((item) => item.resultFor === label)?.result?.[0] || "-";

  // Extract values from result maps
  const card = getResultValue("Card");
  const currTotal = getResultValue("Curr. Total");
  const total = getResultValue("Total");
  const oddEven = getResultValue("Odd/Even");
  const redBlack = getResultValue("Red/Black");

  const cards = casinoCardResultMaps[0]?.result?.filter((card) => card) || [];

  const [currentIndex, setCurrentIndex] = useState(0);
  const cardWidth = 50;
  const maxVisibleCards = 6;
  const sliderWidth = cardWidth * maxVisibleCards;

  const handleArrowClick = (direction) => {
    if (direction === "left" && currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    } else if (
      direction === "right" &&
      currentIndex < cards.length - maxVisibleCards
    ) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  return (
    <div className="modal-dialog modal-xl">
      <div className="modal-content">
        <div className="modal-body">
          <div className="casino-result-modal">
            <div className="casino-result-round-id">
              <span>
                <b>Round Id: </b> {marketId}
              </span>
              <span>
                <b>Match Time: </b>{" "}
                {createdAt
                  ? new Date(createdAt + "Z").toLocaleString()
                  : "Unknown"}
              </span>
            </div>

            <div className="row mt-2 ab-result-container">
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={() => handleArrowClick("left")}
                  style={{
                    position: "absolute",
                    left: "10px",
                    background: "none",
                    border: "none",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                  disabled={currentIndex === 0}
                >
                  &#8592;
                </button>
                <div
                  style={{
                    display: "flex",
                    overflow: "hidden",
                    width: `${sliderWidth}px`,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      transform: `translateX(-${
                        currentIndex * cardWidth
                      }px)`,
                      transition: "transform 0.3s ease-in-out",
                    }}
                  >
                    {cards.map((card, idx) => (
                      <img
                        key={idx}
                        src={`https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/${card}.png`}
                        alt={`Card ${idx + 1}`}
                        style={{
                          width: `${cardWidth}px`,
                          marginRight: "5px",
                          borderRadius: "5px",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                      />
                    ))}
                  </div>
                </div>
                <button
                  onClick={() => handleArrowClick("right")}
                  style={{
                    position: "absolute",
                    right: "10px",
                    background: "none",
                    border: "none",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                  disabled={currentIndex >= cards.length - maxVisibleCards}
                >
                  &#8594;
                </button>
              </div>
            </div>

            <div className="row mt-2 justify-content-center">
              <div className="col-md-6">
                <div className="casino-result-desc">
                  <div className="casino-result-desc-item">
                    <div>Card</div>
                    <div>{card}</div>
                  </div>
                  <div className="casino-result-desc-item">
                    <div>Curr. Total</div>
                    <div>{currTotal}</div>
                  </div>
                  <div className="casino-result-desc-item">
                    <div>Total</div>
                    <div>{total}</div>
                  </div>
                  <div className="casino-result-desc-item">
                    <div>Odd/Even</div>
                    <div>{oddEven}</div>
                  </div>
                  <div className="casino-result-desc-item">
                    <div>Red/Black</div>
                    <div>{redBlack}</div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
}
